var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGutter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_173_3682)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M4.83463 4.7356H11.3635V8.00001H4.83463V4.7356Z",
    fill: "#00C2FF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8714 1.9375V14.0625H0.326935V3.80288L5.30109 3.18089V7.53364H10.8972V2.55949L15.8714 1.9375ZM14.9387 3.00252L11.8299 3.37559V8.46633H4.3684V4.24591L1.25963 4.61898V13.1298H14.9387V3.00252Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.793243 11.2644H15.405V12.1971H0.793243V11.2644Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_173_3682"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.0991211)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGutter);
export default __webpack_public_path__ + "static/media/gutter.e184dcb8fdf22f782aa9e6e5de7152d3.svg";
export { ForwardRef as ReactComponent };